export const SHOWCASE_PATH = '/auto-test/showcase'
export const DEMO_SHOWCASE_PATH = '/demo/auto-test/showcase'

export function isShowcasePath(pathname: string): boolean {
  return pathname === SHOWCASE_PATH || pathname === DEMO_SHOWCASE_PATH
}
